import React, { Component, createRef } from 'react'
import { withFirebase } from '../../components/Fb'
import algoliasearch from 'algoliasearch'
import { createNullCache } from '@algolia/cache-common'
import TextField from '@mui/material/TextField'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import { Paper, Popper, MenuItem, MenuList, ClickAwayListener } from '@mui/material'

const algoliaclient = algoliasearch('6WV1D95IXL', 'd7e7d2238757ecd7bfd520b2b3a5562f', {
  responsesCache: createNullCache()
})
const algoliaindex = algoliaclient.initIndex('falcon_combined')

// The venue's person register, as the search box sees it: hits with `id` = the person's uid.
export const searchVenuePersons = async (query, customerid) => {
  const { hits } = await algoliaindex.search(query, { filters: '_tags:' + customerid })
  return hits
    .filter((x) => x.email && x.email.indexOf('_reg') < 0 && x.email.indexOf('_del') < 0)
    .map(({ objectID, _highlightResult, ...rest }) => ({ ...rest, id: objectID }))
}

class PersonSearch extends Component {
  constructor(props) {
    super(props)
    this.state = { values: [], hits: null, menuopen: false }
    this.anchorEl = createRef()
  }

  updateAdornment = () => {
    this.setState({ startAdornment: this.getStartAdornment() })
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.values !== this.props.values) {
      this.setState({ values: this.props.values }, this.updateAdornment)
    }
  }

  componentDidMount = () => {
    if (!this.props.values) return
    if (this.props.onlyone) {
      this.setState({ values: [this.props.values[0]] }, this.updateAdornment)
    } else {
      this.setState({ values: this.props.values }, this.updateAdornment)
    }
  }

  clearAlgolia = (x) => {
    x.id = x.objectID
    delete x._highlightResult
    delete x.lastmodified
    delete x.reservationAlert
    delete x.objectID
    return x
  }

  handleChange = (e) => {
    const search = e.target.value
    if (search.length > 2) {
      // The typed text is shown at once. It used to be set only when Algolia answered, so the
      // controlled input threw away every key typed while a search was in flight.
      this.setState({ search })
      algoliaindex.search(search, { filters: '_tags:' + this.props.firebase.customerid }).then(({ hits }) => {
        // an answer for text the user has already typed past is stale
        if (this.state.search !== search) return
        const searchresults = hits
          .filter((x) => x.email && x.email.indexOf('_reg') < 0 && x.email.indexOf('_del') < 0)
          .map((x) => this.clearAlgolia(x))
        if (searchresults.length > 0) {
          this.setState({ hits: searchresults, menuopen: true })
        } else {
          this.setState({ hits: null, menuopen: false })
        }
      })
    } else {
      this.setState({ search, hits: null, menuopen: false })
    }
  }

  add = (option) => {
    const { values } = this.state
    const _values = values.filter((x) => x) 
    console.log('add', option, _values)
    if (_values.indexOf(option) > -1) return
    console.log('add1.5', _values)
    if (this.props.onlyone && _values.length > 1) return
    console.log('add2', _values)
    _values.push(option)
    console.log('add3', _values)
    this.setState({ values: _values, hits: null, search: '' } , (() => this.setState({ startAdornment: this.getStartAdornment() })))
    if (this.props.onChange) this.props.onChange(this.props.name, _values)
  }

  remove = (option) => {
    const { values } = this.state
    const index = values.indexOf(option)
    values.splice(index, 1)
    this.setState({ values, startAdornment: this.getStartAdornment() })
    if (this.props.onChange) this.props.onChange(this.props.name, values)
  }

  renderHit = (option) => {
    const title = option.firstname && option.lastname ? option.firstname + ' ' + option.lastname : ''
    return (<MenuItem key={option.objectID}  onClick={() => this.add(option)}>
        <Grid container alignItems='center'>
          <Grid item xs style={{ cursor: 'pointer' }}>
            <span>{title}</span>
            <Typography variant='body2' color='textSecondary'>
              {option.email}
            </Typography>
          </Grid>
        </Grid>
    </MenuItem>)
  }

  handleClose = () => {
    this.setState({ menuopen: false })
  }

  // showEmail: the chip names the email too, so two people with the same name can be told
  // apart once picked. A missing name falls back to the email rather than 'undefined'.
  chipLabel = (data) => {
    const name = [data.firstname, data.lastname].filter(Boolean).join(' ')
    if (!this.props.showEmail) return name || data.email || ''
    if (!name) return data.email || ''
    return data.email ? name + ' · ' + data.email : name
  }

  getStartAdornment = () => {
    if (!this.state.values) return null
    return (
      <div
        style={{
          display: 'flex',
          listStyle: 'none',
          margin: 0,
          flexDirection: this.props.variant === 'list' ? 'column' : 'row',
        }}
      >
        {this.state.values.map((data) => {
          if(!data) return null
          return (
            <li key={data.id}>
              <Chip
                label={this.chipLabel(data)}
                onDelete={() => this.remove(data)}
                style={{ margin: 2 }}
              />
            </li>
          )
        })}
      </div>
    )
  }

  render = () => {
    let inputProps = { startAdornment: this.state.startAdornment }
    if (this.props.variant === 'list') inputProps = {}
    return (
      <div>
        <div ref={this.anchorEl}>
          <TextField
            id='search'
            type='search'
            margin={this.props.margin || 'normal'}
            variant='standard'
            label={this.props.label || 'Lisää ohjaaja/ohjaajia'}
            placeholder={this.props.placeholder || 'Etsi'}
            value={this.state.search}
            onChange={this.handleChange}
            InputProps={inputProps}
            fullWidth={this.props.fullWidth || false}
          />
        </div>
        {this.props.variant === 'list' ? (<div style={{ marginTop: 10 }}>{this.state.startAdornment}</div>) : null}
        <Popper open={this.state.menuopen} anchorEl={this.anchorEl.current} role={undefined} placement={'bottom-start'} style={{ maxHeight: 300, zIndex: 9999 }}>
          <Paper style={{ maxHeight: 300 }}>
          <ClickAwayListener onClickAway={this.handleClose}>
            <MenuList id='menu-list-grow' style={{ maxHeight: 300, overflow: 'auto' }}>
              {this.state.hits && this.state.hits.map((hit) => this.renderHit(hit))}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Popper>
      </div>
    )
  }
}

export default withFirebase(PersonSearch)
